import { useLiquidContextStore } from "@/pinia/liquidContextStore";
import { useAppsStore } from "@/pinia/appsStore";
import {
  supportsPopUpButtonFontSize,
  supportsPopUpButtonLayout,
} from "@/utils/prompts/promptHelpers";

export default {
  computed: {
    message() {
      const liquidContextStore = useLiquidContextStore();
      return liquidContextStore.liquidify(this.actions.rf_retention_message);
    },
    mobileMessage() {
      const liquidContextStore = useLiquidContextStore();
      return liquidContextStore.liquidify(this.actions.rf_mobile_message);
    },
    fillColor() {
      return this.actions.rf_settings_fill_color;
    },
    buttonLabelFontSizeStyle() {
      if (!supportsPopUpButtonFontSize(this.model)) return {};

      return {
        "font-size": `${this.actions.rf_retention_button_font_size || 18}px`,
      };
    },
    buttonsStyle() {
      if (this.newButtonStyles)
        return {
          "border-radius": this.actions.rf_retention_button_border_radius,
          "border-color": this.actions.rf_retention_button_border_color,
          "border-width": this.actions.rf_retention_button_border_thickness,
          "border-style":
            this.actions.rf_retention_button_border_thickness &&
            this.actions.rf_retention_button_border_thickness !== "0px"
              ? "solid"
              : "unset",
          "text-decoration": "none",
          ...(this.model.device_type === "web"
            ? { "min-width": "150px" }
            : { "min-width": "200px" }),
          "cursor": "pointer",
          "padding": "1rem 2rem",
          "line-height": "normal",
        };

      if (
        supportsPopUpButtonLayout(this.model, useAppsStore().app?.flags?.native_popup_button_layout)
      ) {
        const styles = {};
        if (this.actions.button_height) styles.height = `${this.actions.button_height}px`;
        if (this.actions.button_bottom_padding)
          styles["margin-bottom"] = `${this.actions.button_bottom_padding}px`;
        if (this.actions.button_width || this.actions.button_width_percent) {
          styles.width = this.actions.button_width
            ? `${this.actions.button_width}px`
            : `${this.actions.button_width_percent}%`;
          styles["margin-left"] = "auto";
          styles["margin-right"] = "auto";
        }
        return styles;
      }

      return {};
    },
    acceptButtonStyle() {
      return {
        "color": this.actions.button1_text_color,
        "background-color": this.actions.button1_bg_color,
        ...this.buttonsStyle,
        ...this.buttonLabelFontSizeStyle,
        ...(this.newButtonStyles && this.getButtonStyle("button1")),
      };
    },
    secondaryButtonStyle() {
      return {
        "color": this.actions.button2_text_color,
        "background-color": this.actions.button2_bg_color,
        ...this.buttonsStyle,
        ...this.buttonLabelFontSizeStyle,
        ...(this.newButtonStyles && this.getButtonStyle("button2")),
      };
    },
    cancelButtonStyle() {
      const result = {
        color: this.actions.button3_text_color,
        backgroundColor: this.actions.button3_bg_color,
        ...this.buttonsStyle,
        ...this.buttonLabelFontSizeStyle,
        ...(this.newButtonStyles && this.getButtonStyle("button3")),
      };

      return result;
    },
    closeButtonEnabled() {
      return `${this.actions.rf_settings_close_button_enabled}` === "true";
    },
  },
  methods: {
    getButtonStyle(prefix) {
      const rootElement = document.querySelector(
        ".rfmodal-content.outer-modal.rf-device-web.rf-modal-content-wrapper",
      );
      const parentElement = document.querySelector(".rfmodal-text-container");
      const rootElementDimensions = rootElement?.getBoundingClientRect();
      const parentElementDimensions = parentElement?.getBoundingClientRect();
      const offset = {
        x:
          (rootElementDimensions?.x - parentElementDimensions?.x) *
            (1920 / rootElementDimensions?.width) || 0,
        y:
          (rootElementDimensions?.y - parentElementDimensions?.y) *
            (1080 / rootElementDimensions?.height) || 0,
      };
      return {
        ...(this.actions[`${prefix}_width`] && {
          "min-width": this.actions[`${prefix}_width`],
          "width": this.actions[`${prefix}_width`],
          "padding": 0,
        }),
        ...(this.actions[`${prefix}_height`] && {
          "min-height": this.actions[`${prefix}_height`],
          "height": this.actions[`${prefix}_height`],
          "padding": 0,
        }),
        ...(this.actions.button_absolute_position === "true" &&
          this.translateButtonDims(
            this.actions[`${prefix}_position_x`],
            this.actions[`${prefix}_position_y`],
            offset,
          )),
      };
    },
    translateButtonDims(posX = "0px", posY = "0px", offset = { x: 0, y: 0 }) {
      const positionY = (posY || "0px").split("px")[0];
      const positionX = (posX || "0px").split("px")[0];
      return {
        position: "absolute",
        bottom: `${+positionY + offset.y}px`,
        left: `${+positionX + offset.x}px`,
      };
    },
  },
};
